module.exports = __webpack_public_path__ + "0b4ac1dc75df35e169b70d7719afe4cc.ttf";